module.exports = __webpack_public_path__ + "img/benifit-2.3e93b34.png";